export const WORKSPACES_DOCS_URL = 'https://www.sanity.io/docs/workspaces'
